var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 70,
    viewBox: "0 0 42 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6105 1.13694C6.76202 2.74542 2.23214 6.76296 0.510217 13.2005C-0.0927714 15.4549 0.00601707 19.1537 0.00601707 19.1537C0.00601707 19.1537 3.22148 19.2542 6.95614 19.2542C10.3963 19.2542 13.7121 19.2542 13.7121 19.2542C13.7121 19.2542 13.8098 16.9031 14.0146 16.2164C15.447 11.4157 23.594 10.106 26.5183 14.4287C27.4258 15.6351 28.1316 17.2045 28.1316 19.1537C28.1316 24.2807 22.1899 27.2747 19.1648 31.2959C16.1397 35.3171 14.0146 39.8628 14.0146 44.6883V48.4079H26.115L26.4174 44.7888C26.8208 42.175 28.8375 39.3602 33.4759 34.4342C41.0386 26.3918 43.7423 20.542 40.8892 12.1952C39.2482 7.39443 37.2591 4.55495 32.5198 2.24276C26.873 -0.471547 18.5598 -0.572075 12.6105 1.13694Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.24 61.9576C28.24 66.3993 24.6284 70 20.1732 70C15.718 70 12.1063 66.3993 12.1063 61.9576C12.1063 57.5159 15.718 53.9152 20.1732 53.9152C24.6284 53.9152 28.24 57.5159 28.24 61.9576Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.d0f5e613.svg";
export { ForwardRef as ReactComponent };